import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgArrowDownOutline = function SvgArrowDownOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C12.4142 3 12.75 3.33579 12.75 3.75V18.4393L17.7197 13.4697C18.0126 13.1768 18.4874 13.1768 18.7803 13.4697C19.0732 13.7626 19.0732 14.2374 18.7803 14.5303L12.5303 20.7803C12.2374 21.0732 11.7626 21.0732 11.4697 20.7803L5.21967 14.5303C4.92678 14.2374 4.92678 13.7626 5.21967 13.4697C5.51256 13.1768 5.98744 13.1768 6.28033 13.4697L11.25 18.4393V3.75C11.25 3.33579 11.5858 3 12 3Z"
  })));
};

export { SvgArrowDownOutline as ReactComponent };
//# sourceMappingURL=arrow-down-outline.svg.js.map
